/* eslint-disable camelcase */
import { isDate, format } from 'date-fns';

export const DEFAULT_SERIALIZERS = [
  serializeDates,
  serializeGender,
  serializeDegreesDummy,
  serializeRegions,
  serializeJobType,
  serializeJobFunction,
  serializeCvUpload
];

export function makeSerializer(serializers) {
  return initialData =>
    serializers.reduce((data, serializer) => serializer(data), initialData);
}

export function serializeDates(data) {
  return Object.keys(data).reduce((result, key) => {
    let value = data[key];

    if (isDate(value)) {
      value = format(value, 'yyyy-MM-dd');
    }
    result[key] = value; // eslint-disable-line no-param-reassign
    return result;
  }, {});
}

const GENDER_MAP = {
  male: true,
  female: false
};

export function serializeGender({ gender, diverse_gender_options, ...data }) {
  if (diverse_gender_options) {
    let diverseGender = gender;

    if (!gender) {
      diverseGender = 'unspecified';
    }
    return {
      ...data,
      gender: diverseGender
    };
  }

  let isMale = GENDER_MAP[gender];
  if (typeof isMale !== 'boolean') {
    isMale = null;
  }
  return {
    ...data,
    gender
  };
}

export function serializeDegreesDummy(data) {
  const { degrees, ...restData } = data;
  if (!degrees || !degrees.education) {
    return data;
  }

  const { education, ...restDegrees } = degrees;

  return {
    ...restData,
    degrees: [{ ...restDegrees, education_id: education.id }]
  };
}

export function serializeSelectListData(field, data) {
  const fieldValues = data[field];

  if (!fieldValues) {
    return data;
  }

  const fieldsIds = fieldValues.map(val => val.id);

  return {
    ...data,
    [field]: fieldsIds
  };
}

export function serializeRegions(data) {
  return serializeSelectListData('region_ids', data);
}

export function serializeJobFunction(data) {
  return serializeSelectListData('function_ids', data);
}

export function serializeJobType(data) {
  return serializeSelectListData('job_type_ids', data);
}

export function serializeCvUpload(data) {
  const { upload_cv, ...restData } = data;
  return restData;
}
